module.exports = __webpack_public_path__ + "img/30.61a3e151.svg";